import { COORDINATE_LIMIT } from '../constants';

export default function limitCoordinate(value) {
    return Math.max(Math.min(value, COORDINATE_LIMIT), -COORDINATE_LIMIT);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-gauges/node_modules/@progress/kendo-charts/dist/es/core/utils/limit-coordinate.js
// module id = 972
// module chunks = 29